import { render, staticRenderFns } from "./BTextArea.vue?vue&type=template&id=352033c3&scoped=true&"
import script from "./BTextArea.vue?vue&type=script&lang=js&"
export * from "./BTextArea.vue?vue&type=script&lang=js&"
import style0 from "./BTextArea.vue?vue&type=style&index=0&id=352033c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352033c3",
  null
  
)

export default component.exports